export default "__VITE_ASSET__f73122a5__"